module.exports = __webpack_public_path__ + "static/media/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA.140f0f0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA.jpg
// module id = 784
// module chunks = 0